import { render, staticRenderFns } from "./TotalBlockItem.vue?vue&type=template&id=9f7b2562&scoped=true"
import script from "./TotalBlockItem.vue?vue&type=script&lang=js"
export * from "./TotalBlockItem.vue?vue&type=script&lang=js"
import style0 from "./TotalBlockItem.vue?vue&type=style&index=0&id=9f7b2562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7b2562",
  null
  
)

export default component.exports